export default "__VITE_ASSET__CjC0rUfi__"